const makeInitialState = unreconciledAmount => ({
  contract: null,
  isPayoffRequest: false,
  amount:
    unreconciledAmount != null && Number(unreconciledAmount) > 0
      ? String(unreconciledAmount)
      : ''
});

export default makeInitialState;
